import { createTranslationMessages } from '@backstage/frontend-plugin-api';
import { TranslationBlueprint } from '@backstage/plugin-app-react';
import { catalogTranslationRef } from '@backstage/plugin-catalog/alpha';

export const catalogTranslation = TranslationBlueprint.make({
  name: 'catalog',
  params: {
    resource: createTranslationMessages({
      ref: catalogTranslationRef,
      full: false,
      messages: {
        'indexPage.title': 'Catalogus van {{orgName}}',
        'indexPage.createButtonTitle': 'Aan de slag',
        'indexPage.supportButtonContent':
          'Alle entiteiten in je softwarecatalogus',
        'entityPage.notFoundMessage':
          'Er is geen {{kind}} met de gevraagde {{link}}.',
        'entityPage.notFoundLinkText': 'soort, naamruimte en naam',
        'aboutCard.title': 'Over',
        'aboutCard.refreshButtonTitle': 'Plan verversing van entiteit',
        'aboutCard.editButtonTitle': 'Bewerk metadata',
        'aboutCard.editButtonAriaLabel': 'Bewerk',
        'aboutCard.createSimilarButtonTitle': 'Maak iets vergelijkbaars',
        'aboutCard.refreshScheduledMessage': 'Verversing gepland',
        'aboutCard.refreshButtonAriaLabel': 'Ververs',
        'aboutCard.launchTemplate': 'Start template',
        'aboutCard.viewTechdocs': 'Documentatie bekijken',
        'aboutCard.viewSource': 'Broncode bekijken',
        'aboutCard.unknown': 'onbekend',
        'aboutCard.descriptionField.label': 'Beschrijving',
        'aboutCard.descriptionField.value': 'Geen beschrijving',
        'aboutCard.ownerField.label': 'Eigenaar',
        'aboutCard.ownerField.value': 'Geen eigenaar',
        'aboutCard.domainField.label': 'Domein',
        'aboutCard.domainField.value': 'Geen domein',
        'aboutCard.systemField.label': 'Systeem',
        'aboutCard.systemField.value': 'Geen systeem',
        'aboutCard.parentComponentField.label': 'Bovenliggend component',
        'aboutCard.parentComponentField.value': 'Geen bovenliggend component',
        'aboutCard.kindField.label': 'Soort',
        'aboutCard.typeField.label': 'Type',
        'aboutCard.lifecycleField.label': 'Levenscyclus',
        'aboutCard.tagsField.label': 'Tags',
        'aboutCard.tagsField.value': 'Geen tags',
        'aboutCard.targetsField.label': 'Doelen',
        'searchResultItem.kind': 'Soort',
        'searchResultItem.type': 'Type',
        'searchResultItem.lifecycle': 'Levenscyclus',
        'searchResultItem.owner': 'Eigenaar',
        'catalogTable.warningPanelTitle':
          'De entiteiten in de catalogus konden niet worden opgehaald.',
        'catalogTable.viewActionTitle': 'Bekijk',
        'catalogTable.editActionTitle': 'Bewerk',
        'catalogTable.starActionTitle': 'Voeg toe aan favorieten',
        'catalogTable.unStarActionTitle': 'Verwijder uit favorieten',
        'catalogTable.allFilters': 'Alle',
        'dependencyOfComponentsCard.title': 'Afhankelijkheid van componenten',
        'dependencyOfComponentsCard.emptyMessage':
          'Geen enkel component is afhankelijk van dit component.',
        'dependsOnComponentsCard.title': 'Afhankelijk van componenten',
        'dependsOnComponentsCard.emptyMessage':
          'Dit component is van geen enkel ander component afhankelijk.',
        'dependsOnResourcesCard.title': 'Afhankelijk van resources',
        'dependsOnResourcesCard.emptyMessage':
          'Dit component is van geen enkele resource afhankelijk.',
        'entityContextMenu.copiedMessage': 'Gekopieerd',
        'entityContextMenu.moreButtonTitle': 'Meer',
        'entityContextMenu.inspectMenuTitle': 'Inspecteer entiteit',
        'entityContextMenu.copyURLMenuTitle': 'Kopieer URL van entiteit',
        'entityContextMenu.unregisterMenuTitle':
          'Trek registratie van entiteit in',
        'entityContextMenu.moreButtonAriaLabel': 'Meer acties',
        'entityLabelsCard.title': 'Labels',
        'entityLabelsCard.columnKeyLabel': 'Label',
        'entityLabelsCard.columnValueLabel': 'Waarde',
        'entityLabelsCard.emptyDescription':
          'Deze entiteit heeft geen labels. Je kunt labels toevoegen aan de YAML van je entiteit, zoals in het gemarkeerde voorbeeld hieronder:',
        'entityLabelsCard.readMoreButtonTitle': 'Meer informatie',
        'entityLabels.warningPanelTitle': 'Entiteit niet gevonden',
        'entityLabels.ownerLabel': 'Eigenaar',
        'entityLabels.lifecycleLabel': 'Levenscyclus',
        'entityLabels.systemLabel': 'Systeem',
        'entityLabels.domainLabel': 'Domein',
        'entityLabels.partOfLabel': 'Onderdeel van',
        'entityLinksCard.title': 'Links',
        'entityLinksCard.emptyDescription':
          'Deze entiteit heeft geen links. Je kunt links toevoegen aan de YAML van je entiteit, zoals in het gemarkeerde voorbeeld hieronder:',
        'entityLinksCard.readMoreButtonTitle': 'Meer informatie',
        'entityNotFound.title': 'Entiteit niet gevonden',
        'entityNotFound.description':
          'Wil je hieraan meebouwen? Bekijk dan onze documentatie om te beginnen.',
        'entityNotFound.docButtonTitle': 'Documentatie',
        'entityTabs.tabsAriaLabel': 'Tabbladen',
        'deleteEntity.dialogTitle':
          'Weet je zeker dat je deze entiteit wilt verwijderen?',
        'deleteEntity.deleteButtonTitle': 'Verwijder',
        'deleteEntity.cancelButtonTitle': 'Annuleer',
        'deleteEntity.description':
          'Geen enkele locatie verwijst naar deze entiteit. Ze krijgt daarom geen updates.',
        'deleteEntity.actionButtonTitle': 'Verwijder entiteit',
        'catalogExportButton.triggerButtonTitle': 'Exporteer selectie',
        'catalogExportButton.dialogTitle': 'Exporteer selectie uit catalogus',
        'catalogExportButton.formatLabel': 'Formaat',
        'catalogExportButton.columnsLabel': 'Kolommen',
        'catalogExportButton.cancelButtonTitle': 'Annuleer',
        'catalogExportButton.confirmButtonTitle': 'Bevestig',
        'catalogExportButton.exportingButtonTitle': 'Exporteren…',
        'catalogExportButton.successMessage': 'De catalogus is geëxporteerd',
        'catalogExportButton.errorMessage':
          'Exporteren van de catalogus is mislukt: {{errorMessage}}',
        entityProcessingErrorsDescription:
          'De onderstaande fout is afkomstig van',
        entityRelationWarningDescription:
          'Deze entiteit heeft relaties met andere entiteiten die niet in de catalogus staan.\n Niet gevonden entiteiten: ',
        'hasComponentsCard.title': 'Heeft componenten',
        'hasComponentsCard.emptyMessage':
          'Geen enkel component is onderdeel van dit systeem.',
        'hasResourcesCard.title': 'Heeft resources',
        'hasResourcesCard.emptyMessage':
          'Geen enkele resource is onderdeel van dit systeem.',
        'hasSubcomponentsCard.title': 'Heeft subcomponenten',
        'hasSubcomponentsCard.emptyMessage':
          'Geen enkel subcomponent is onderdeel van dit component.',
        'hasSubdomainsCard.title': 'Heeft subdomeinen',
        'hasSubdomainsCard.emptyMessage':
          'Geen enkel subdomein is onderdeel van dit domein.',
        'hasSystemsCard.title': 'Heeft systemen',
        'hasSystemsCard.emptyMessage':
          'Geen enkel systeem is onderdeel van dit domein.',
        'relatedEntitiesCard.emptyHelpLinkTitle': 'Lees hoe je dit wijzigt.',
        'systemDiagramCard.title': 'Systeemdiagram',
        'systemDiagramCard.description':
          'Knijp en zoom om door het diagram te bewegen.',
        'systemDiagramCard.edgeLabels.partOf': 'onderdeel van',
        'systemDiagramCard.edgeLabels.provides': 'biedt aan',
        'systemDiagramCard.edgeLabels.dependsOn': 'hangt af van',
      },
    }),
  },
});
